import { styled } from '@linaria/react';
import { colors, layout, space } from '../../theme/tokens';

export const GridSkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${space[3]};
  overflow: hidden;
  background: ${colors.white};
`;

export const GridSkeletonImage = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: ${space[3]};
  background: linear-gradient(
    90deg,
    ${colors.lighterGrey} 0px,
    ${colors.borderGreyLighter} 200px,
    ${colors.lighterGrey} 400px
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

export const GridSkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  padding: ${space[4]} 0 0;
`;

export const SkeletonLine = styled.div<{ $width?: string; $height?: string }>`
  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || '14px'};
  border-radius: ${space[1]};
  background: linear-gradient(
    90deg,
    ${colors.lighterGrey} 0px,
    ${colors.borderGreyLighter} 200px,
    ${colors.lighterGrey} 400px
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

export const ListSkeletonCard = styled.div`
  display: flex;
  gap: ${space[5]};
  border-bottom: 1px solid ${colors.borderGrey};
  padding-bottom: ${space[5]};
`;

export const ListSkeletonImage = styled.div`
  width: 240px;
  height: 160px;
  flex-shrink: 0;
  border-radius: ${space[3]};
  background: linear-gradient(
    90deg,
    ${colors.lighterGrey} 0px,
    ${colors.borderGreyLighter} 200px,
    ${colors.lighterGrey} 400px
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }

  @media (max-width: ${layout.desktopBreakpoint}) {
    width: 120px;
    height: 100px;
  }
`;

export const ListSkeletonContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${space[2]};
  min-width: 0;
`;

export const ListSkeletonFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${space[3]};
`;

export const SkeletonRow = styled.div`
  display: flex;
  gap: ${space[4]};
  overflow: hidden;
`;
